const DISPLAY_NAME_RE = /^[\p{L}\p{N}_\- #]+$/u;

export function normalizeDisplayName(name: string): string {
  return name.trim().replace(/\s+/g, ' ');
}

export function isValidDisplayName(name: string): boolean {
  if (name.length < 2 || name.length > 32) return false;
  return DISPLAY_NAME_RE.test(name);
}
